import API from '@/api';

const GET_PRODUCTS = 'GET_PRODUCTS';
const GET_PRODUCTS_SUCCESS = 'GET_PRODUCTS_SUCCESS';
const GET_PRODUCTS_FAILED = 'GET_PRODUCTS_FAILED';
const GET_PRODUCT = 'GET_PRODUCTS';
const GET_PRODUCT_SUCCESS = 'GET_PRODUCT_SUCCESS';
const GET_PRODUCT_FAILED = 'GET_PRODUCT_FAILED';
const RESET_PRODUCT_DETAILS = 'RESET_PRODUCT_DETAILS';

const ADD_PRODUCT_TO_CART = 'ADD_PRODUCT_TO_CART';
const ADD_PRODUCT_TO_CART_SUCCESS = 'ADD_PRODUCT_TO_CART_SUCCESS';
const ADD_PRODUCT_TO_CART_FAILED = 'ADD_PRODUCT_TO_CART_FAILED';

const INCREASE_PRODUCT_SUCCESS = 'INCREASE_PRODUCT_SUCCESS';
const INCREASE_PRODUCT_FAILED = 'INCREASE_PRODUCT_FAILED';
const DECREASE_PRODUCT_SUCCESS = 'DECREASE_PRODUCT_SUCCESS';
const DECREASE_PRODUCT_FAILED = 'DECREASE_PRODUCT_FAILED';

const REMOVE_PRODUCT_FROM_CART = 'REMOVE_PRODUCT_FROM_CART';
const REMOVE_PRODUCT_FROM_CART_SUCCESS = 'REMOVE_PRODUCT_FROM_CART_SUCCESS';
const REMOVE_PRODUCT_FROM_CART_FAILED = 'REMOVE_PRODUCT_FROM_CART_FAILED';

const GET_CART = 'GET_CART';
const GET_CART_SUCCESS = 'GET_CART_SUCCESS';
const GET_CART_FAILED = 'GET_CART_FAILED';

const DELETE_CART = 'DELETE_CART';
const DELETE_CART_FAILED = 'DELETE_CART_FAILED';
const DELETE_CART_SUCCESS = 'DELETE_CART_SUCCESS';

const GET_ORDER_TAX = 'GET_ORDER_TAX';
const GET_ORDER_TAX_SUCCESS = 'GET_ORDER_TAX_SUCCESS';
const GET_ORDER_TAX_FAILED = 'GET_ORDER_TAX_FAILED';
const RESET_ORDER_TAX = 'RESET_ORDER_TAX';
const STOP_LOADING_TAX = 'STOP_LOADING_TAX';
const STOP_LOADING = 'STOP_LOADING';

const GET_ORDER_DETAILS = 'GET_ORDER_DETAILS';
const GET_ORDER_DETAILS_SUCCESS = 'GET_ORDER_DETAILS_SUCCESS';
const GET_ORDER_DETAILS_FAILED = 'GET_ORDER_DETAILS_FAILED';
const RESET_ORDER_DETAILS = 'RESET_ORDER_DETAILS';

const RESEND_ORDER_RECEIPT = 'RESEND_ORDER_RECEIPT';
const RESEND_ORDER_RECEIPT_SUCCESS = 'RESEND_ORDER_RECEIPT_SUCCESS';
const RESEND_ORDER_RECEIPT_FAILED = 'RESEND_ORDER_RECEIPT_FAILED';

const GET_ORDER_HISTORY = 'GET_ORDER_HISTORY';
const GET_ORDER_HISTORY_SUCCESS = 'GET_ORDER_HISTORY_SUCCESS';
const GET_ORDER_HISTORY_FAILED = 'GET_ORDER_HISTORY_FAILED';
const RESET_ORDER_HISTORY = 'RESET_ORDER_HISTORY';

const GET_PAYMENT_INTENT = 'GET_PAYMENT_INTENT';
const GET_PAYMENT_INTENT_SUCCESS = 'GET_PAYMENT_INTENT_SUCCESS';
const GET_PAYMENT_INTENT_FAILED = 'GET_PAYMENT_INTENT_FAILED';

const CREATE_SUBSCRIPTION = 'CREATE_SUBSCRIPTION';
const CREATE_SUBSCRIPTION_SUCCESS = 'CREATE_SUBSCRIPTION_SUCCESS';
const CREATE_SUBSCRIPTION_FAILED = 'CREATE_SUBSCRIPTION_FAILED';
const CANCEL_SUBSCRIPTION = 'CANCEL_SUBSCRIPTION';
const CANCEL_SUBSCRIPTION_SUCCESS = 'CANCEL_SUBSCRIPTION_SUCCESS';
const CANCEL_SUBSCRIPTION_FAILED = 'CANCEL_SUBSCRIPTION_FAILED';

const PUSH_PRODUCT_TO_CART = 'PUSH_PRODUCT_TO_CART';
const INCREASE_ITEM_QUANTITY = 'INCREASE_ITEM_QUANTITY';
const DECREASE_ITEM_QUANTITY = 'DECREASE_ITEM_QUANTITY';
const SET_CHECKOUT_STATUS = 'SET_CHECKOUT_STATUS';
const EMPTY_CART = 'EMPTY_CART';

const GET_SHOP_DATA = 'GET_SHOP_DATA';
const GET_SHOP_DATA_FAILED = 'GET_SHOP_DATA_FAILED';
const GET_SHOP_DATA_SUCCESS = 'GET_SHOP_DATA_SUCCESS';

// Enabled the module to be namespaced
const namespaced = true;

const productTypeTextSwitch = (response) => {
  let text = '';
  switch (response.data.productType) {
    case 'purchase':
      text = 'Purchase';
      break;
    case 'consumable':
      // text = 'Rental';
      text = 'Purchase';
      break;
    case 'subscription':
      text = 'Subscription';
      break;

    default:
      break;
  }
  return text;
};

const dispatchTax = (commit, dispatch, res) => {
  if (res?.shipTo?.postalCode && res?.subTotal) {
    const taxPayload = {
      shipto: {
        postalcode: res?.shipTo?.postalCode,
      },
      subTotal: res.subTotal,
      userID: res.userID,
      // subscriptionID: to get discounted amount maybe here
    };

    dispatch('getTax', taxPayload);
  } else {
    commit(STOP_LOADING_TAX);
  }
};

//* Products initial state
const state = {
  products: [],
  product: {},
  cart: {
    items: [],
  },
  checkoutStatus: null,
  loading: false,
  paymentIntent: null,
  orderDetails: {},
  orderProductKeys: [],
  orderHistory: [],
  orderTax: null,
  loadingTax: false,
  loadingReceipt: false,
};

const emptyState = {
  products: [],
  product: {},
  cart: {
    items: [],
  },
  checkoutStatus: null,
  loading: false,
  paymentIntent: null,
  orderDetails: {},
  orderProductKeys: [],
  orderHistory: [],
  orderTax: null,
  loadingTax: false,
  loadingReceipt: false,
};

//! Temp to fake purchasing
function buyProducts(products, cb, errorCb) {
  setTimeout(() => {
    // simulate random checkout failure.
    Math.random() > 0.5 || navigator.userAgent.indexOf('PhantomJS') > -1 ? cb() : errorCb();
  }, 100);
}

//* Shop getters
const getters = {
  list: (state) => {
    return state.products;
  },

  product: (state) => {
    return state.product;
  },

  loading: (state) => {
    return state.loading;
  },

  loadingTax: (state) => {
    return state.loadingTax;
  },

  loadingReceipt: (state) => {
    return state.loadingReceipt;
  },

  cart: (state) => {
    return state.cart;
  },

  paymentIntent: (state) => {
    return state.paymentIntent;
  },

  orderDetails: (state) => {
    return state.orderDetails;
  },

  orderProductKeys: (state) => {
    return state?.orderProductKeys || [];
  },

  orderHistory: (state) => {
    return state?.orderHistory?.filter((order) => {
      return order.status === 'succeeded';
    });
  },

  cartProducts(state) {
    if (state?.cart?.items) {
      return state?.cart?.items?.map((cartItem) => {
        const product = state?.cart?.items?.find(
          (product) => {
            return (
              product.productID === cartItem.productID &&
              product.forLicense === cartItem.forLicense &&
              product.forType === cartItem.forType
            );
          }
          // return (
          //   (product.productID === cartItem.id || product.id === cartItem.id) &&
          //   product.license &&
          //   product.license.licenseId === cartItem.license.licenseId
          // );
        );

        return {
          ...product,
          // webTitle: product.titleText || product.title || product.webTitle,
          // priceInDollars: product.priceInDollars,
          // productID: product.productID,
          // skuCode: product.skuCode,
          // productType: product.productType,
          // productCategory: product.productCategory,
          // interval: product.interval,
          // quantity: cartItem.quantity,
          // license: product.license,
          // user: product.user,
        };
      });
    }
    return [];
  },

  cartTotal(state, getters) {
    // const total = 0;
    // getters.cartProducts.forEach(product => {
    //   total += product.price * product.quantity;
    // });
    // return total;

    const total = getters.cartProducts.reduce(
      (total, product) =>
        //* console.log('product:', product);
        //* const productPrice = product.discountPrice ? product.discountPrice : product.price;
        //* return total + productPrice * product.quantity;
        // total + product.price * product.quantity,
        {
          return total + product.price * product.quantity;
        },
      //* (total, product) => total + product.priceInDollars * product.quantity,
      0
    );
    // console.log('total:', total + state.cart.totalTax);
    const taxVal = state?.cart?.totalTax ?? 0;
    return total + taxVal;
  },

  cartItemTotal(state, getters) {
    return getters.cartProducts.reduce((quantity, product) => {
      return quantity + product.quantity;
    }, 0);
  },

  orderTax: (state) => {
    return state.orderTax?.tax;
  },

  orderTaxInfo: (state) => {
    return state.orderTax;
  },
};

//* Shop actions
const actions = {
  //* list fetches the Products list from the API
  async list({ commit }, payload = {}) {
    let response;

    commit(GET_PRODUCTS);

    try {
      const filters = payload?.filter?.split(',');
      response = await API.shop.list(payload);

      response.data = response.data.filter((data) => {
        if (!payload.filter || !filters.length) {
          return true;
        }
        return filters.includes(data?.productType?.toLowerCase()) && data.status !== 'disabled';
      });
    } catch (err) {
      response = err;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_PRODUCTS_FAILED);
        reject(response);
      } else {
        commit(GET_PRODUCTS_SUCCESS, response.data);
        // * Return GET data with promise
        resolve(response.data);
      }
    });
  },

  //* show fetches the individual Product from the API
  async show({ commit }, payload) {
    let response;

    commit(GET_PRODUCT);

    try {
      response = await API.shop.show(payload);

      const text = productTypeTextSwitch(response);

      if (response.data.productType.text === undefined) {
        response.data.productType = {
          type: response.data.productType,
          text,
        };
      }

      if (!response?.data?.isWeb || response?.data?.status !== 'active') {
        response.data = {};
      }
    } catch (err) {
      response = err;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_PRODUCT_FAILED);
        reject(response);
      } else {
        commit(GET_PRODUCT_SUCCESS, response.data);
        // * Return GET data with promise
        resolve(response.data);
      }
    });
  },

  //* showSku fetches the individual Product from the API by skucode
  async showSku({ commit }, payload) {
    let response;

    commit(GET_PRODUCT);

    try {
      response = await API.shop.showSku(payload);

      const text = productTypeTextSwitch(response);

      if (response.data.productType.text === undefined) {
        response.data.productType = {
          type: response.data.productType,
          text,
        };
      }

      if (!response?.data?.isWeb || response?.data?.status !== 'active') {
        response.data = {};
      }
    } catch (err) {
      response = err;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_PRODUCT_FAILED);
        reject(response);
      } else {
        commit(GET_PRODUCT_SUCCESS, response.data);
        // * Return GET data with promise
        resolve(response.data);
      }
    });
  },

  async createCart({ commit }, payload) {
    let response = {};

    commit(GET_CART);

    try {
      response = await API.shop.createCart(payload);
      if (!response.data.items) {
        response.data.items = [];
      }
    } catch (err) {
      response = err;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_CART_FAILED);
        reject(response);
      } else {
        commit(GET_CART_SUCCESS, response.data);
        // * Return GET data with promise
        resolve(response.data);
      }
    });
  },

  async getCart({ commit }, payload) {
    let response = {};

    commit(GET_CART);

    try {
      response = await API.shop.getCart(payload);
      if (!response.data.items) {
        response.data.items = [];
      }
    } catch (err) {
      response = err;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_CART_FAILED);
        reject(response);
      } else {
        commit(GET_CART_SUCCESS, response.data);
        // * Return GET data with promise
        resolve(response.data);
      }
    });
  },

  //* Delete the entire cart
  async deleteCart({ commit }, payload) {
    let response = {};

    commit(DELETE_CART);

    localStorage.removeItem('redeem_payload');
    localStorage.removeItem('redeem_productPayload');
    localStorage.removeItem('redeem_licenseID');

    try {
      response = await API.shop.deleteCart(payload);
    } catch (err) {
      response = err;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(DELETE_CART_FAILED);
        reject(response);
      } else {
        commit(DELETE_CART_SUCCESS, response.data);
        // * Return GET data with promise
        resolve(response.data);
      }
    });
  },

  async addProductToCart({ state, commit, getters, dispatch }, product) {
    const physicalCategories = ['simulators', 'tgMini', 'replacementItem'];
    const permissionCategories = ['userPermission'];
    let response = {};
    const {
      productID,
      user,
      license,
      cartID,
      promotion,
      productCode,
      setPrice,
      skuCode,
      productCategory,
      bypassDuplicateCheck = false,
      bypassAddToCartPayAndPauseCheck = false,
      delay_start: delayStart = false,
      delay_time: delayTime = null,
      discount = null,
      discount_type = null, // subscription_upgrade if doing upgrade
      subscription_id = null,
    } = product;

    commit(ADD_PRODUCT_TO_CART);

    const forType = product?.productType?.type !== 'productCode' ? 'license' : 'productcode';

    const payload = {
      // "productID": 35,
      // "SKUCode":"sku",
      // "Quantity":1,
      // "Price": 1299,
      // "trugolfPricingID":"tpr_b5e018771b4cc7f",
      // "forType":"license",
      // "forLicense":"3ca84a4a-397d-4c0f-a613-90ce515533b11111",
      // "forUser":"c2b7f848-c09d-4350-807b-e3066e812f31111",
      // "forLicenseType": "desktop"
      // ====================
      Price: setPrice.price,
      Quantity: 1,
      SKUCode: skuCode,
      bypassDuplicateCheck,
      bypassAddToCartPayAndPauseCheck,
      delay_start: delayStart,
      delay_time: delayTime,
      forLicense: license?.licenseId === '000000' ? null : license?.licenseId, //* not used for permission product
      forLicenseType: forType === 'license' ? license?.type : productCode.productCodeType, //* not used for permission product
      forType: license?.licenseId === '000000' ? 'license.create' : forType,
      forUser: user?.id,
      productID,
      trugolfPricingID: setPrice.trugolfPricingID,
      discount,
      discountType: discount_type,
      ...(subscription_id && { subscription_id }),
    };

    if (physicalCategories.includes(productCategory)) {
      payload.forLicense = null;
      payload.forLicenseType = null;
      payload.forType = 'purchase';
    }
    if (permissionCategories.includes(productCategory)) {
      payload.forLicense = null;
      payload.forLicenseType = null;
      payload.forType = 'userPermission';
    }

    const { items } = getters.cart;
    const hasSubscription = items.some((item) => {
      return item.producttype === 'subscription';
    });

    if (hasSubscription && payload?.forType !== 'productcode') {
      commit(ADD_PRODUCT_TO_CART_FAILED);
      return;
    }

    const cartItem = state.cart.items.find(
      (item) => {
        if (physicalCategories.includes(productCategory)) {
          return item.productID === product.productID && item.forType === 'purchase';
        }
        return (
          item.productID === product.productID &&
          item.forLicense === license.licenseId &&
          item.forType === (product.productType.type === 'purchase' ? 'license' : 'productcode')
        );
      }
      // item.productID === product.productID && item.license.licenseId === product.license.licenseId;
    );

    if (cartItem) {
      // cartItem.quantity++;
      dispatch('increaseQuantity', {
        ...cartItem,
      });
      return;
    }

    try {
      response = await API.shop.addToCart(payload);
    } catch (err) {
      response = err;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(ADD_PRODUCT_TO_CART_FAILED);
        reject(response);
      } else {
        commit(ADD_PRODUCT_TO_CART_SUCCESS, response.data);
        // * Return GET data with promise
        resolve(response.data);
      }
    });
  },

  // removeFromCart({ state, commit }, product) {
  //   const cartItem = state.cart.find(
  //     item =>
  //       // item => item.productID === product.productID && item.forLicense === product.forLicense
  //       item.productID === product.productID && item.license.licenseId === product.license.licenseId
  //   );
  //   const index = state.cart.indexOf(cartItem);

  //   if (index > -1) {
  //     commit(REMOVE_PRODUCT_FROM_CART, index);
  //   }
  // },

  async increaseQuantity({ state, commit, dispatch }, product) {
    let response = {};
    commit(ADD_PRODUCT_TO_CART);

    const cartItem = state?.cart?.items?.find(
      (item) => {
        return (
          item.productID === product.productID &&
          item.forLicense === product.forLicense &&
          item.itemID === product.itemID &&
          item.forType === product.forType
        );
      }
      // item.productID === product.productID && item.license.licenseId === product.license.licenseId
    );

    if (cartItem) {
      cartItem.quantity++;
      // commit(PUSH_PRODUCT_TO_CART, product.id);
      try {
        response = await API.shop.updateCartItem(cartItem);

        commit(GET_ORDER_TAX);
        dispatch('getCart').then((res) => {
          dispatchTax(commit, dispatch, res);
        });
      } catch (err) {
        response = err;
      }

      return new Promise((resolve, reject) => {
        if (response.status >= 400) {
          commit(INCREASE_PRODUCT_FAILED);
          reject(response);
        } else {
          commit(INCREASE_PRODUCT_SUCCESS, response.data);
          // * Return GET data with promise
          resolve(response.data);
        }
      });
    }
    // } else {
    //   commit(INCREASE_ITEM_QUANTITY, cartItem);
    // }
  },

  async decreaseQuantity({ state, commit, dispatch }, product) {
    let response = {};
    const cartItem = state.cart.items.find(
      (item) => {
        return (
          item.productID === product.productID &&
          item.forLicense === product.forLicense &&
          item.itemID === product.itemID &&
          item.forType === product.forType
        );
      }
      // item.productID === product.productID && item.license.licenseId === product.license.licenseId
    );
    // const index = state.cart.items.indexOf(cartItem);

    if (cartItem && cartItem.quantity > 1) {
      // commit(DECREASE_ITEM_QUANTITY, cartItem);
      cartItem.quantity--;
      try {
        response = await API.shop.updateCartItem(cartItem);

        commit(GET_ORDER_TAX);
        dispatch('getCart').then((res) => {
          dispatchTax(commit, dispatch, res);
        });
      } catch (err) {
        response = err;
      }

      return new Promise((resolve, reject) => {
        if (response.status >= 400) {
          commit(DECREASE_PRODUCT_FAILED);
          reject(response);
        } else {
          commit(DECREASE_PRODUCT_SUCCESS, response.data);
          // * Return GET data with promise
          resolve(response.data);
        }
      });
    }

    //! delete product
    dispatch('removeProduct', product);
    // commit(REMOVE_PRODUCT_FROM_CART, index);
  },

  async removeProduct({ state, commit, dispatch }, product) {
    let response = {};
    commit(REMOVE_PRODUCT_FROM_CART);

    localStorage.removeItem('redeem_payload');
    localStorage.removeItem('redeem_productPayload');
    localStorage.removeItem('redeem_licenseID');

    const cartItem = state?.cart?.items.find(
      (item) => {
        return (
          item.productID === product.productID &&
          item.forLicense === product.forLicense &&
          item.itemID === product.itemID &&
          item.forType === product.forType
        );
      }
      // item.productID === product.productID && item.license.licenseId === product.license.licenseId
    );
    const index = state?.cart?.items?.indexOf(cartItem);

    if (cartItem || cartItem.quantity <= 0) {
      // commit(DECREASE_ITEM_QUANTITY, cartItem);
      try {
        response = await API.shop.removeProduct(cartItem);
        dispatch('getCart').then((res) => {
          if (!state?.cart?.items?.length) {
            dispatch('resetTax');
            dispatch('deleteCart');
            setTimeout(() => {
              dispatch('getCart');
            }, 1000);
            // commit(DELETE_CART_SUCCESS, '');
          } else if (res?.zipcode && res?.subTotal) {
            const taxPayload = {
              zipcode: res.zipcode,
              subTotal: res.subTotal,
              userID: res.userID,
            };

            dispatch('getTax', taxPayload);
          }
        });
      } catch (err) {
        response = err;
      }

      return new Promise((resolve, reject) => {
        if (response.status >= 400) {
          commit(REMOVE_PRODUCT_FROM_CART_FAILED);
          reject(response);
        } else {
          commit(REMOVE_PRODUCT_FROM_CART_SUCCESS, index);
          // * Return GET data with promise
          resolve(response.data);
        }
      });
    }

    //* delete product
    // commit(REMOVE_PRODUCT_FROM_CART, index);
  },

  // checkout({ state, commit, dispatch }, payload) {
  //   console.log('checkout payload:', payload);
  //   dispatch('emptyCart', payload);
  //   // commit(SET_CHECKOUT_STATUS, 'success');

  //   // //* Mock do checkout stuff here
  //   // buyProducts(
  //   //   state.cart,
  //   //   () => {
  //   //     commit(EMPTY_CART);
  //   //     commit(SET_CHECKOUT_STATUS, 'success');
  //   //   },
  //   //   () => {
  //   //     commit(SET_CHECKOUT_STATUS, 'failure');
  //   //   }
  //   // );
  // },

  async getPaymentIntent({ commit }, payload) {
    // @ Total
    // @ userID

    let response = {};
    commit(GET_PAYMENT_INTENT);

    try {
      response = await API.shop.paymentIntent(payload);
    } catch (err) {
      response = err;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_PAYMENT_INTENT_FAILED);
        reject(response);
      } else {
        commit(GET_PAYMENT_INTENT_SUCCESS, response.data);
        // * Return GET data with promise
        resolve(response.data);
      }
    });
  },

  async fulfillTransaction({ commit, dispatch }, payload) {
    // console.log('fulfillTransaction payload:', payload);
    // @ paymentIntentID
    // @ userID
    // @ total
    // @ mailto

    let response = {};
    commit(GET_PAYMENT_INTENT);

    try {
      response = await API.shop.fulfillTransaction(payload);
    } catch (err) {
      response = err;
    }

    // return response;

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(STOP_LOADING_TAX);
        commit(STOP_LOADING);
        reject(response);
      } else {
        dispatch('getCart');
        resolve(response.data);
      }
    });
  },

  async createSubscription({ commit, dispatch }, payload) {
    let response = {};
    commit(CREATE_SUBSCRIPTION);

    try {
      response = await API.shop.createSubscription(payload);
    } catch (err) {
      response = err;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(CREATE_SUBSCRIPTION_FAILED);
        reject(response);
      } else {
        commit(CREATE_SUBSCRIPTION_SUCCESS, response.data);
        // * Return GET data with promise
        // TODO Check this
        // dispatch('emptyCart', payload);
        dispatch('getCart');
        resolve(response.data);
      }
    });
  },

  async cancelSubscription({ commit }, payload) {
    let response = {};
    commit(CANCEL_SUBSCRIPTION);

    try {
      response = await API.shop.cancelSubscription(payload);
    } catch (err) {
      response = err;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(CANCEL_SUBSCRIPTION_FAILED);
        reject(response);
      } else {
        commit(CANCEL_SUBSCRIPTION_SUCCESS, response.data);
        // * Return GET data with promise
        resolve(response.data);
      }
    });

    // TODO Check this
    // dispatch('emptyCart', payload);
  },

  // @ {
  // @   "transactionID": "CLTGP-D3DBV-B6CJC-J47UG" example
  // @   "subscriptionID": "sub_1Jhik9BvdHrUob1CZT8SJLHA" example
  // @ }
  async updateTransactionID({ commit }, payload) {
    let response = {};

    try {
      response = await API.shop.updateTransactionID(payload);
    } catch (err) {
      response = err;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        reject(response);
      } else {
        // * Return data with promise
        resolve(response.data);
      }
    });
  },

  // @ {
  // @   "transactionID": "CLTGP-D3DBV-B6CJC-J47UG" example
  // @   "redeemedAt": "2022-11-07T22:53:12.604973Z" example
  // @ }
  async updateTransactionDate({ commit }, payload) {
    let response = {};

    try {
      response = await API.shop.updateTransactionDate(payload);
    } catch (err) {
      response = err;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        reject(response);
      } else {
        // * Return data with promise
        resolve(response.data);
      }
    });
  },

  //* check webook log
  async webhookLog({ commit }, { subID, retries }) {
    let response = {};
    commit(CREATE_SUBSCRIPTION);

    try {
      response = await API.shop.webhookLog({ subID, retries });

      if (response?.data?.length === 2) {
        return new Promise((resolve, reject) => {
          if (response.status >= 400) {
            commit(CREATE_SUBSCRIPTION_FAILED);
            reject(response);
          } else {
            commit(CREATE_SUBSCRIPTION_SUCCESS, response.data);
            // * Return data with promise
            resolve(response.data);
          }
        });
      }

      return new Promise((resolve, reject) => {
        commit(CREATE_SUBSCRIPTION_FAILED);
        reject(response);
      });
    } catch (err) {
      console.error('err:', err);
      response = err;
    }
  },

  emptyCart({ commit, dispatch }, payload) {
    // TODO double check this
    if (payload && payload.products) {
      payload.products.forEach((item) => {
        dispatch('removeProduct', item);
      });
    }
    commit(EMPTY_CART);
  },

  async getOrderDetails({ commit }, payload) {
    let response = {};
    commit(GET_ORDER_DETAILS);

    // const clubTestRes = {
    //   cart: {
    //     cartID: 1804,
    //     userID: '3eaef7a7-7592-45b4-9896-30175a5f9424',
    //     userGivenName: '',
    //     userFamilyName: '',
    //     subTotal: 3000,
    //     totalTax: 218,
    //     total: 3218,
    //     subTotalAvalara: 3000,
    //     status: 'succeeded',
    //     transactionID: 'txnp_cf70c4e0b6db37dc111',
    //     orderedAt: '2023-10-02T15:58:59.474698Z',
    //     createdAt: '2023-10-02T15:35:34.7066Z',
    //     updatedAt: '2023-10-02T16:40:05.369406Z',
    //     items: [
    //       {
    //         itemID: 1479,
    //         cartID: 1804,
    //         productID: 184,
    //         skucode: 'CLUBTST1',
    //         productCategory: 'userPermission',
    //         producttype: 'purchase',
    //         webtitle: 'Clubhouse Test Product',
    //         price: 3000,
    //         quantity: 1,
    //         forType: 'userPermission',
    //         forLicenseType: '',
    //         forUser: '64d9eb15-cf2f-4c8b-bd17-fb282b8b8beb',
    //         trugolfPricingID: 'tpr_a81639f3bdcb47dd8ea6c46fa0404cef',
    //         transactionID: 'txnc_67770164f975bcd9',
    //         taxcode: 'DG010300',
    //         fishbowlPartNumber: '2596',
    //         stripePricingID: '',
    //         delay_start: false,
    //         BetterSubscription: null,
    //       },
    //     ],
    //     shipTo: {
    //       id: 347,
    //       firstName: 'Clint',
    //       lastName: 'Losee',
    //       phoneNumber: '',
    //       email: 'clintl@trugolf.com',
    //       line1: '200 main st',
    //       city: 'West Jordan',
    //       region: 'UT',
    //       country: 'US',
    //       postalCode: '84084',
    //       cartID: 1804,
    //       createdAt: '2023-10-02T15:35:34.7066Z',
    //       updatedAt: '2023-10-02T16:40:05.369406Z',
    //     },
    //     billTo: {
    //       id: 347,
    //       firstName: 'Clint',
    //       lastName: 'Losee',
    //       phoneNumber: '',
    //       email: 'clintl@trugolf.com',
    //       line1: '200 main st',
    //       city: 'West Jordan',
    //       region: 'UT',
    //       country: 'US',
    //       postalCode: '84084',
    //       cartID: 1804,
    //       createdAt: '2023-10-02T15:35:34.7066Z',
    //       updatedAt: '2023-10-02T16:40:05.369406Z',
    //     },
    //     cart_type: 'purchase',
    //     shipping_options: {
    //       RateResponse: {
    //         Response: {
    //           ResponseStatus: {
    //             Code: '',
    //             Description: '',
    //           },
    //           Alert: null,
    //           TransactionReference: {
    //             CustomerContext: '',
    //           },
    //         },
    //         RatedShipment: null,
    //       },
    //     },
    //   },
    //   productKeys: null,
    // };

    try {
      response = await API.shop.getOrderDetails(payload);

      //! TEST SETUP - REMOVE
      // response.data = clubTestRes;
    } catch (err) {
      response = err;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_ORDER_DETAILS_FAILED);
        reject(response);
      } else {
        commit(GET_ORDER_DETAILS_SUCCESS, response.data);
        // * Return GET data with promise
        resolve(response.data);
      }
    });
  },

  async getOrderHistory({ commit }, payload) {
    let response = {};
    commit(GET_ORDER_HISTORY);

    try {
      response = await API.shop.getOrderHistory(payload);

      if (!response?.data && response?.status <= 200) {
        response.data = [];
      }

      if (Array.isArray(response?.data)) {
        //* Set delayStart flag from items on order for price display
        response.data = response?.data?.map((order) => {
          const delayStart = order?.items?.some((item) => {
            return item?.delay_start ?? false;
          });
          return { ...order, delayStart };
        });
      }

      //* Testing to get subscription details. Off for now.
      // response.data = await Promise.all(
      //   response?.data?.map(async (transaction) => {
      //     console.log('transaction:', transaction);
      //     if (transaction.cart_type === 'subscription') {
      //       const subscriptionDetails = await API.shop.getSubscription(transaction.transactionID);
      //       console.log('subscriptionDetails:', subscriptionDetails);
      //       if (subscriptionDetails?.data) {
      //         return {
      //           ...transaction,
      //           subscriptionDetails: subscriptionDetails.data,
      //         };
      //       }
      //     }
      //     return transaction;
      //   })
      // );
    } catch (err) {
      response = err;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_ORDER_HISTORY_FAILED);
        reject(response);
      } else {
        commit(GET_ORDER_HISTORY_SUCCESS, response.data);
        // * Return GET data with promise
        resolve(response.data);
      }
    });
  },

  //* resetProductDetails resets show to {}
  async resetProductDetails({ commit }) {
    commit(RESET_PRODUCT_DETAILS);
  },

  resetOrderDetails({ commit }) {
    commit(RESET_ORDER_DETAILS);
  },

  resetOrderHistory({ commit }) {
    commit(RESET_ORDER_HISTORY);
  },

  //* set up a reset tax call
  resetTax({ commit }) {
    commit(RESET_ORDER_TAX);
  },

  //* Call to compute order tax
  // @ shipto: {
  // @   "postalcode": ""
  // @ },
  // @ "subTotal": ,
  // @ "userID": ""
  // @ subscription_id: to get discounted total
  async getTax({ commit, dispatch }, payload) {
    let response = {};

    commit(GET_ORDER_TAX);

    try {
      response = await API.shop.getTax(payload);
      dispatch('getCart');
    } catch (err) {
      response = err;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_ORDER_TAX_FAILED);
        reject(response);
      } else {
        commit(GET_ORDER_TAX_SUCCESS, response.data);
        // * Return GET data with promise
        resolve(response.data);
      }
    });
  },

  //* Resend Order Receipt to Email
  async resendOrderReceipt({ commit }, payload) {
    let response = {};
    commit(RESEND_ORDER_RECEIPT);

    try {
      response = await API.shop.resendOrderReceipt(payload);
    } catch (err) {
      response = err;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(RESEND_ORDER_RECEIPT_FAILED);
        reject(response);
      } else {
        commit(RESEND_ORDER_RECEIPT_SUCCESS);
        resolve(response.data);
      }
    });
  },

  //* Manage Billing
  async manageBilling(_, payload) {
    let response = {};

    try {
      response = await API.shop.manageBilling(payload);
    } catch (err) {
      response = err;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        reject(response);
      } else {
        resolve(response.data);
      }
    });
  },

  //* Get latest transaction by sku
  async getLatestTransactionBySku(_, payload) {
    let response = {};

    try {
      response = await API.shop.getLatestTransactionBySku(payload);
    } catch (err) {
      response = err;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        reject(response);
      } else {
        resolve(response.data);
      }
    });
  },

  //* Get subscripton upgrade info
  async subscriptionUpgradeCheck(_, payload) {
    let response = {};

    try {
      response = await API.shop.subscriptionUpgradeCheck(payload);
    } catch (err) {
      response = err;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        reject(response);
      } else {
        resolve(response.data);
      }
    });
  },

  //* Get list of applicable subscripton upgrade products
  async subscriptionUpgradeProductList(_, payload) {
    let response = {};

    try {
      response = await API.shop.subscriptionUpgradeProductList(payload);
    } catch (err) {
      response = err;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        reject(response);
      } else {
        resolve(response.data);
      }
    });
  },

  //* Add special/zero dollar product to license
  async addSpecialProduct({ commit }, payload) {
    let response = {};
    commit(GET_SHOP_DATA);

    try {
      response = await API.shop.addSpecialProduct(payload);
    } catch (err) {
      response = err;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_SHOP_DATA_FAILED);
        reject(response);
      } else {
        commit(GET_SHOP_DATA_SUCCESS);
        resolve(response.data);
      }
    });
  },
};

//* Shop mutations
const mutations = {
  [GET_PRODUCTS](state) {
    state.loading = true;
  },

  [GET_PRODUCTS_SUCCESS](state, products = []) {
    state.products = products;
    state.loading = false;
  },

  [GET_PRODUCTS_FAILED](state) {
    state.loading = false;
  },

  [GET_PRODUCT](state) {
    state.loading = true;
  },

  [GET_PRODUCT_SUCCESS](state, product) {
    state.product = product;
    state.loading = false;
  },

  [GET_PRODUCT_FAILED](state) {
    state.loading = false;
  },

  [RESET_PRODUCT_DETAILS](state) {
    state.product = {};
    state.loading = false;
  },

  [GET_CART](state) {
    state.loading = true;
  },

  [GET_CART_SUCCESS](state, cart) {
    state.cart = cart;
    state.loading = false;
  },

  [GET_CART_FAILED](state) {
    state.loading = false;
  },

  [DELETE_CART](state) {
    state.loading = true;
  },

  [DELETE_CART_FAILED](state) {
    state.cart = { items: [] };
    state.loading = false;
  },

  [DELETE_CART_SUCCESS](state) {
    state.loading = false;
  },

  [ADD_PRODUCT_TO_CART](state) {
    state.loading = true;
  },

  [ADD_PRODUCT_TO_CART_SUCCESS](state, data) {
    state.cart.items.push({ ...data });
    state.loading = false;
  },

  [ADD_PRODUCT_TO_CART_FAILED](state) {
    state.loading = false;
  },

  [INCREASE_PRODUCT_SUCCESS](state, cartItem) {
    cartItem.quantity++;
    state.loading = false;
  },

  [INCREASE_PRODUCT_FAILED](state) {
    state.loading = false;
  },

  [DECREASE_PRODUCT_SUCCESS](state, cartItem) {
    cartItem.quantity--;
    state.loading = false;
  },

  [DECREASE_PRODUCT_FAILED](state) {
    state.loading = false;
  },

  [REMOVE_PRODUCT_FROM_CART](state) {
    state.loading = true;
  },

  [REMOVE_PRODUCT_FROM_CART_SUCCESS](state, index) {
    state.cart.items.splice(index, 1);
    state.loading = false;
  },

  [REMOVE_PRODUCT_FROM_CART_FAILED](state) {
    state.loading = false;
  },

  [PUSH_PRODUCT_TO_CART](state, product) {
    state.cart.items.push({
      ...product,
      // quantity: 1,
    });
  },

  // [REMOVE_PRODUCT_FROM_CART](state, index) {
  //   state.cart.items.splice(index, 1);
  // },

  [INCREASE_ITEM_QUANTITY](state, cartItem) {
    cartItem.quantity++;
  },

  [DECREASE_ITEM_QUANTITY](state, cartItem) {
    cartItem.quantity--;
  },

  [SET_CHECKOUT_STATUS](state, status) {
    state.checkoutStatus = status;
  },

  [EMPTY_CART](state) {
    state.cart = [];
    state.products = [];
  },

  [GET_PAYMENT_INTENT](state) {
    state.loading = true;
  },

  [GET_PAYMENT_INTENT_SUCCESS](state, data) {
    state.paymentIntent = data;
    state.loading = false;
  },

  [GET_PAYMENT_INTENT_FAILED](state) {
    state.loading = false;
  },

  [CREATE_SUBSCRIPTION](state) {
    state.loading = true;
  },

  [CREATE_SUBSCRIPTION_SUCCESS](state, data) {
    state.loading = false;
  },

  [CREATE_SUBSCRIPTION_FAILED](state) {
    state.loading = false;
  },

  [CANCEL_SUBSCRIPTION](state) {
    state.loading = true;
  },

  [CANCEL_SUBSCRIPTION_SUCCESS](state, data) {
    state.loading = false;
  },

  [CANCEL_SUBSCRIPTION_FAILED](state) {
    state.loading = false;
  },

  [GET_ORDER_DETAILS](state) {
    state.loading = true;
  },

  [GET_ORDER_DETAILS_SUCCESS](state, order) {
    state.orderDetails = order?.cart;
    state.orderProductKeys = order?.productKeys;
    state.loading = false;
  },

  [GET_ORDER_DETAILS_FAILED](state) {
    state.orderDetails = {};
    state.orderProductKeys = [];
    state.loading = false;
  },

  [RESEND_ORDER_RECEIPT](state) {
    state.loadingReceipt = true;
  },

  [RESEND_ORDER_RECEIPT_SUCCESS](state) {
    state.loadingReceipt = false;
  },

  [RESEND_ORDER_RECEIPT_FAILED](state) {
    state.loadingReceipt = false;
  },

  [GET_ORDER_HISTORY](state) {
    state.loading = true;
  },

  [GET_ORDER_HISTORY_SUCCESS](state, data = []) {
    state.orderHistory = data.sort((a, b) => {
      const dateA = new Date(a.createdAt);
      const dateB = new Date(b.createdAt);
      return dateB - dateA;
    });
    state.loading = false;
  },

  [GET_ORDER_HISTORY_FAILED](state) {
    state.loading = false;
  },

  [RESET_ORDER_HISTORY](state) {
    state.orderHistory = [];
    state.loading = false;
  },

  [RESET_ORDER_DETAILS](state) {
    state.orderDetails = {};
    state.orderProductKeys = [];
    state.loading = false;
  },

  [GET_ORDER_TAX](state) {
    state.loadingTax = true;
  },

  [GET_ORDER_TAX_SUCCESS](state, data) {
    state.orderTax = data;
    state.loadingTax = false;
  },

  [GET_ORDER_TAX_FAILED](state) {
    state.loadingTax = false;
  },

  [RESET_ORDER_TAX](state) {
    state.orderTax = null;
    state.loadingTax = false;
  },

  [STOP_LOADING_TAX](state) {
    state.loadingTax = false;
  },

  [STOP_LOADING](state) {
    state.loading = false;
  },

  [GET_SHOP_DATA](state) {
    state.loading = true;
  },

  [GET_SHOP_DATA_FAILED](state) {
    state.loading = false;
  },

  [GET_SHOP_DATA_SUCCESS](state, products = []) {
    state.loading = false;
  },
};

export default {
  namespaced,
  state,
  getters,
  actions,
  mutations,
};
